import { useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { SlidersHorizontal, X } from "lucide-react";

function BrandList({ facets, picked, onChange }) {
  const [q, setQ] = useState("");
  const [all, setAll] = useState(false);
  const toggle = (b) => onChange(picked.includes(b) ? picked.filter((x) => x !== b) : [...picked, b]);
  const list = facets.filter((f) => !q || f.brand.toLowerCase().includes(q.toLowerCase()));
  const visible = all || q ? list : list.slice(0, 10);
  return (
    <>
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-bold text-steel text-sm">Brand</h3>
        {picked.length > 0 && <button onClick={() => onChange([])} className="text-xs text-accent hover:underline flex items-center gap-0.5 min-h-6" data-testid="brand-filter-clear"><X size={12} /> Clear</button>}
      </div>
      {facets.length > 10 && <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Find a brand" aria-label="Find a brand" className="w-full h-9 mb-3 rounded-md border px-2 text-sm focus:outline-none focus:ring-2 focus:ring-accent" data-testid="brand-filter-search" />}
      <div className="space-y-1 max-h-[60vh] lg:max-h-80 overflow-y-auto pr-1">
        {visible.map((f) => (
          <label key={f.brand} className="flex items-center gap-2 text-sm cursor-pointer hover:text-steel min-h-8" data-testid={`brand-filter-${f.brand}`}>
            <Checkbox checked={picked.includes(f.brand)} onCheckedChange={() => toggle(f.brand)} aria-label={f.brand} />
            <span className="flex-1 truncate">{f.brand}</span><span className="text-xs text-muted-foreground">{f.count}</span>
          </label>))}
      </div>
      {!q && list.length > 10 && <button onClick={() => setAll(!all)} className="mt-3 text-xs font-semibold text-accent hover:underline" data-testid="brand-filter-more">{all ? "Show fewer" : `Show all ${list.length}`}</button>}
    </>
  );
}

export function BrandFilter(props) {
  const [open, setOpen] = useState(false);
  const n = props.picked.length;
  return (
    <aside className="lg:w-56 shrink-0" data-testid="brand-filter">
      <button onClick={() => setOpen(true)} className="lg:hidden w-full flex items-center justify-center gap-2 rounded-lg border bg-white px-4 h-11 text-sm font-semibold" data-testid="brand-filter-toggle">
        <SlidersHorizontal size={16} /> Filter by brand{n ? ` (${n})` : ""}
      </button>
      <div className="hidden lg:block rounded-lg border bg-white p-4 lg:sticky lg:top-32"><BrandList {...props} /></div>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-[85%] sm:max-w-sm overflow-y-auto lg:hidden" data-testid="brand-filter-drawer">
          <SheetHeader><SheetTitle>Filters</SheetTitle></SheetHeader>
          <div className="mt-4"><BrandList {...props} /></div>
          <button onClick={() => setOpen(false)} className="mt-6 w-full h-11 rounded-md bg-steel text-white font-semibold" data-testid="brand-filter-apply">Show results</button>
        </SheetContent>
      </Sheet>
    </aside>
  );
}
